/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */
import React from "react";
import styled from "styled-components";

import {APP_COLORS} from "../../common/Constants";
import {Col, Row, Accordion} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown} from "@fortawesome/free-solid-svg-icons";

const HeaderPanel = styled.div `
  background-color: ${APP_COLORS['gray-100']};
  padding: 0.5rem;

  border-width: 0.0125rem;
  border-style: solid;
  border-color: #e7eaf3;
`;

const SearchBarContainer = styled.div `
  margin: 8px 0 8px 15px;
`;

const SearchSubText = styled.div `
  display: flex;
  //margin-left: 1rem;
  font-size: 13px;
  font-style: italic;
  padding: 5px 15px;
`;


const SearchSubTextLocation = styled.div `
  font-weight: 600;
  font-size: 14px;
`;

const CustomAccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px 15px;
  cursor: pointer;
  
  .accordion-button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    box-shadow: none;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    &:focus {
      box-shadow: none;
    }
    
    &:not(.collapsed) {
      background: none;
      box-shadow: none;
      
      svg {
        transform: rotate(180deg);
        transition: transform 0.2s ease-in-out;
      }
    }
    
    &::after {
      display: none; /* Hide the default Bootstrap arrow */
    }
  }
`;

const CustomToggleButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: ${APP_COLORS['gray-600']};
  transition: transform 0.2s ease-in-out, color 0.2s ease-in-out;
  
  &:hover {
    color: ${APP_COLORS['gray-800']};
  }
  
  &:focus {
    outline: none;
    box-shadow: none;
  }
  
  svg {
    transition: transform 0.2s ease-in-out;
  }
`;

const ContractorDirectoryHeader = (props) => {
    const {
        searchBar,
        searchSubText,
        searchSubTextLocation,
        searchOptionsForm
    } = props;

    return (
        <HeaderPanel>
            <Row>
                <Col xl={12} lg={12} md={12} sm={12}>
                    <SearchBarContainer>
                        {searchBar}
                        <Row>
                            <Col xl={12} lg={12} md={12} sm={12}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header as={CustomAccordionHeader}>
                                        <SearchSubText>{searchSubText}&nbsp;<SearchSubTextLocation>{searchSubTextLocation}</SearchSubTextLocation></SearchSubText>
                                        <CustomToggleButton>
                                            <FontAwesomeIcon icon={faAngleDown} />
                                        </CustomToggleButton>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col xl={12} lg={12} md={12} sm={12}>
                                                {searchOptionsForm}
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            </Col>
                        </Row>
                    </SearchBarContainer>
                </Col>
            </Row>
        </HeaderPanel>
    );
}

export default ContractorDirectoryHeader;
